// Kickback — entry. Moduły wpinane w etapach 2-14.
// Etap 4: import './slider.js'; import './reveal.js'; import './whats-new-tabs.js'; import './before-after.js';
// Etap 10: import './exclude-clubs.js';

// ──────────────────────────────────────────────────────────────────────────
// Block all zoom (mobile pinch + desktop Ctrl+wheel + Mac trackpad gestures)
// ──────────────────────────────────────────────────────────────────────────
// Klient wymaga zablokowania zoom na całej stronie. Mobile blok przez viewport
// meta (`maximum-scale=1, user-scalable=no`) + body `touch-action: pan-x pan-y`.
// Desktop blok wheel z Ctrl/Cmd + Safari gesturestart/gesturechange/gestureend.
(function () {
  if (typeof window === 'undefined') return;
  // Desktop: Ctrl+wheel = zoom (Chrome/FF), Cmd+wheel (Mac browsers)
  window.addEventListener('wheel', (e) => {
    if (e.ctrlKey || e.metaKey) e.preventDefault();
  }, { passive: false });
  // Desktop Ctrl/Cmd + (+/-/0)
  window.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '0'].includes(e.key)) {
      e.preventDefault();
    }
  });
  // Safari pinch gestures (trackpad / mobile)
  ['gesturestart', 'gesturechange', 'gestureend'].forEach((evt) => {
    document.addEventListener(evt, (e) => e.preventDefault(), { passive: false });
  });
  // iOS double-tap zoom backup
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) e.preventDefault();
    lastTouchEnd = now;
  }, { passive: false });
})();

// ──────────────────────────────────────────────────────────────────────────
// EWWW Arrive.js disarm — KRYTYCZNE dla iPhone 17 Pro Safari
// ──────────────────────────────────────────────────────────────────────────
// EWWW Image Optimizer dodaje 3 MutationObservers (przez Arrive.js) na
// document.body z subtree:true. Każda zmiana DOM (quickview innerHTML,
// load-more append, cart fragment update) triggeruje pile-up callbacków,
// na iPhone Safari z silnym GPU compositor → memory overflow → crash
// ("Wielokrotnie wystąpił problem"). Rozbrojeniem unbindAllArrive() po DOM ready
// usuwa wszystkie zarejestrowane observers — EWWW dalej serwuje WebP przez
// .htaccess mod_rewrite (server-side), JS rewrite zbędny.
(function () {
  if (typeof document === 'undefined') return;
  const disarmEwww = () => {
    try {
      // Arrive.js dopisuje `arrive`/`unbindAllArrive` do HTMLElement.prototype.
      if (typeof document.unbindAllArrive === 'function') {
        document.unbindAllArrive();
      }
      if (typeof document.unbindAllLeave === 'function') {
        document.unbindAllLeave();
      }
    } catch (_) {}
  };
  // Odpal raz po DOM, raz po load (EWWW może dopiero wtedy registrować).
  if (document.readyState !== 'loading') disarmEwww();
  else document.addEventListener('DOMContentLoaded', disarmEwww);
  window.addEventListener('load', disarmEwww);
})();

if (typeof window !== 'undefined') {
  document.documentElement.classList.add('js');
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  // Bezpiecznik — gdy jakiś moduł rzuci wyjątkiem podczas init (np. po zmianie
  // znacznika WP albo brakującym pluginie), reszta strony niech działa dalej.
  // Loguje do console żeby było widać w Safari Inspector na iPhone.
  window.addEventListener('error', (e) => {
    try { console.warn('[kb] global error:', e.message, e.filename + ':' + e.lineno); } catch (_) {}
  });
  window.addEventListener('unhandledrejection', (e) => {
    try { console.warn('[kb] unhandled rejection:', e.reason && (e.reason.message || e.reason)); } catch (_) {}
  });

  // Safari iOS — Page Lifecycle cleanup.
  // Gdy user przechodzi do tła aplikacji (Home button, switch tab), Safari może
  // KILL strony żeby zaoszczędzić RAM. Bez explicit cleanup powracając do strony
  // dostajemy "Wielokrotnie wystąpił problem". `pagehide` z `persisted=false`
  // znaczy że BFCache nie zadziała → cleanujemy listenery, observery, animacje.
  window.addEventListener('pagehide', (e) => {
    try {
      // Pauza CSS animations w tle (oszczędność GPU + zapobiega bg-rendering crash)
      document.querySelectorAll('.marquee').forEach((m) => { m.style.animationPlayState = 'paused'; });
      // Zwolnij wszystkie disposable observers przez global registry (jeśli skrypty rejestrują)
      if (window.__kbObservers && Array.isArray(window.__kbObservers)) {
        window.__kbObservers.forEach((o) => { try { o.disconnect(); } catch (_) {} });
      }
    } catch (_) {}
  });

  window.addEventListener('pageshow', (e) => {
    try {
      // Resume marquee gdy wrócimy do strony (po pagehide pause)
      document.querySelectorAll('.marquee').forEach((m) => { m.style.animationPlayState = ''; });
    } catch (_) {}
  });
}

// Bezpieczny wrap dla każdego import — jeśli moduł rzuci podczas init,
// reszta strony działa. (esbuild bundles synchronicznie, jeden throw przed
// `window.addEventListener('error')` mógłby aborte WSZYTKICH następnych
// importów. To dodatkowy net na top-level.)
const __kbSafeInit = (name, fn) => { try { fn(); } catch (e) { try { console.warn('[kb] init failed:', name, e && e.message); } catch (_) {} } };
// Re-export bezpieczny helper żeby moduły mogły go używać dla swoich init.
if (typeof window !== 'undefined') { window.__kbSafeInit = __kbSafeInit; }

import './header.js';
import './mega-menu.js';
import './mobile-drawer.js';
import './search-drawer.js';
import './filter-drawer.js';
import './sort-dropdown.js';
import './quickview-drawer.js';
import './cart-drawer.js';
import './pdp-variations.js';
import './pdp-size-select.js';
import './pdp-gallery.js';
import './sticky-atc.js';
import './pdp-ajax-atc.js';
import './load-more.js';
// import './inpost-picker.js'; // wyłączone — używamy pluginu wysyłkowego (Furgonetka.pl / Apaczka.pl) z natywnym pickerem
import './slider.js';
import './hero-slider.js';
import './nav-hydrate.js';
import './mobile-drawer-hydrate.js';
import './loyalty-motion.js';
import './reveal.js';
import './whats-new-tabs.js';
import './before-after.js';
import './cart-qty.js';
import './cart-coupon.js';
import './checkout.js';
import './exclude-clubs.js';
import './blog-share.js';
import './focus-trap.js';
import './cookie-banner.js';
import './newsletter.js';
import './thankyou-upsell.js';
import './page-loader.js';
import './pdp-zoom.js';
import './filter-pill.js';
import './skup.js';
